import "./index.scss";

import { Button, ButtonGroup } from "@mui/material";
import { nanoid } from "nanoid";
import { useEffect, useState } from "react";

const RatingBar = ({ numberOfButtons = 5, value, onChange, startFromZero = false }) => {
  const [selectedValue, setSelectedValue] = useState<number>();

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const isButtonSelected = (index: number) => {
    if (startFromZero) return index === selectedValue;
    return index === selectedValue - 1;
  };

  //#region event handlers
  const handleRatingSelection = (v: number) => {
    onChange(startFromZero ? v : v + 1);
  };
  //#endregion event handlers

  return (
    <ButtonGroup className="button-group rating-bar">
      {Array(numberOfButtons)
        .fill(null)
        .map((_m, index) => (
          <Button
            key={nanoid()}
            className={isButtonSelected(index) ? `active` : ``}
            onClick={() => handleRatingSelection(index)}
          >
            {startFromZero ? index : index + 1}
          </Button>
        ))}
    </ButtonGroup>
  );
};

export default RatingBar;
